module.exports = __webpack_public_path__ + "img/Yin.0c77e5ce.jpeg";